import { UtilitiesService } from '../../services/utilities.service';

export class PushNotification {

    public id: string;
    public notification: Notification;

    constructor(notification: Notification) {
        this.id = new Date().getTime().toString();
        this.notification = notification;
    }

}